exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._1MDd{display:block;position:relative;float:left;width:100%}", ""]);

// exports
exports.locals = {
	"root": "_1MDd",
	"root": "_1MDd"
};


//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"camelCase":true,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:4]","minimize":true}!../~/postcss-loader?pack=default!./containers/singleRealisation/singleRealisation.css
// module id = 248
// module chunks = 0